import routes from './chats.routes';

export const chatsModule = {
    routes
};